import PropTypes from 'prop-types';
import React from 'react';
import { useUpdateResourceRequestHandlers } from '~/modules/projects/resourcing-plan/hooks';
import { RequestStatusLabel } from '~/modules/resourcing/common/components';
import { ResourceLoadingField } from '~/modules/resourcing/common/chart/components';
import RolesMenuListDropdown from '~/modules/common/components/RolesMenuListDropdown';
import { useHasPermission } from '~/modules/common/permissions';
import {
  ResourceRequestDetailIndicator,
  ResourceRequestQuantityField
} from '../components';
import useStyles, {
  useRoleStyles,
  useStatusStyles,
  useQuantityStyles,
  useLoadingStyles
} from './useStyles';

export const ResourceRequestEditableItem = ({
  qeIdTag,
  resourceRequest,
  defaultScheduleRule,
  maxSkillLevel
}) => {
  const classes = useStyles();

  const roleClasses = useRoleStyles();
  const statusClasses = useStatusStyles();
  const quantityClasses = useQuantityStyles();
  const loadingClasses = useLoadingStyles({
    isAdjustedLoading: resourceRequest.isAdjustedLoading
  });

  const canViewRole = useHasPermission({
    actionUri: 'urn:replicon:project-role-action:view-project-role'
  });

  const { load, quantity, role, isAdjustedLoading } = resourceRequest;

  const {
    onRoleChange,
    onQuantityChange,
    onLoadChange
  } = useUpdateResourceRequestHandlers({
    resourceRequest,
    defaultScheduleRule
  });

  return (
    <div className={classes.rangeItem}>
      <div className={classes.itemContainer}>
        <div className={classes.labelRow}>
          <RolesMenuListDropdown
            dataQeId={
              qeIdTag ? `RowRoleDropDown${qeIdTag}` : 'RoleRoleDropDown'
            }
            showSelectRole
            classes={roleClasses}
            assignedRole={role}
            onChange={onRoleChange}
            includeSkills={canViewRole}
          />
          <RequestStatusLabel
            classes={statusClasses}
            value={resourceRequest.requestStatus}
            short
          />
        </div>
        <div className={classes.labelRow}>
          <ResourceRequestQuantityField
            dataQeId={
              qeIdTag ? `RowQuantityInput${qeIdTag}` : 'RowQuantityInput'
            }
            classes={quantityClasses}
            value={quantity}
            onChange={onQuantityChange}
          />
          <span className={classes.atDivider}>@</span>
          <ResourceLoadingField
            dataQeId={
              qeIdTag ? `RowPercentInput${qeIdTag}` : 'RowPercentageInput'
            }
            classes={loadingClasses}
            value={load}
            max={999}
            isAdjustedLoading={isAdjustedLoading}
            onChange={onLoadChange}
          />
          <ResourceRequestDetailIndicator
            maxSkillLevel={maxSkillLevel}
            resourceRequest={resourceRequest}
          />
        </div>
      </div>
    </div>
  );
};

ResourceRequestEditableItem.propTypes = {
  qeIdTag: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  defaultScheduleRule: PropTypes.object,
  maxSkillLevel: PropTypes.number
};

export default ResourceRequestEditableItem;
